import React, { memo } from 'react';
export var PwaLoader = memo(function (_a) {
    var text = _a.text;
    return React.createElement("div", { className: "pwa" },
        React.createElement("h2", null, text),
        React.createElement("p", null, "Na\u010D\u00EDt\u00E1m..."));
});
